import FavoriteIcon from 'assets/icons/photo/FavoriteIcon'
import MediaTypesIcon from 'assets/icons/photo/MediaTypesIcon'
import BuckIcon from 'assets/icons/photo/BuckIcon'

export const FILTER_SPYPOINT_ICON_BY_KEY = {
  favorite: FavoriteIcon,
  mediaTypes: MediaTypesIcon,
  species: BuckIcon,
}
